var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { staticClass: "mb-5" },
        [
          _c("span", { staticClass: "mr-2" }, [_vm._v("Добавить фильтр")]),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: {
                small: "",
                disabled: _vm.isLoading,
                loading: _vm.isLoading,
              },
              on: {
                click: function ($event) {
                  return _vm.mixAddListItemItemHandler(
                    "where",
                    _vm.$options.widgetItems
                  )
                },
              },
            },
            [_c("v-icon", { attrs: { small: "" } }, [_vm._v(" mdi-plus ")])],
            1
          ),
        ],
        1
      ),
      _vm._l(
        _vm.listItem.data.where,
        function (listItemItem, listItemItemIndex) {
          return _c(
            "v-row",
            {
              key: listItemItemIndex,
              staticClass: "my-5",
              attrs: { align: "center" },
            },
            [
              _c(
                "v-col",
                { attrs: { cols: "2" } },
                [
                  _c("v-select", {
                    attrs: {
                      outlined: "",
                      "item-value": "value",
                      "item-text": "title",
                      "return-object": "",
                      "hide-details": "",
                      dense: "",
                      disabled: _vm.isLoading,
                      loading: _vm.isLoading,
                      value: listItemItem.data.field,
                      items: _vm.$options.fieldList,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.updateWidgetField($event, listItemItemIndex)
                      },
                    },
                  }),
                ],
                1
              ),
              listItemItem.data.field !== null
                ? _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c("v-select", {
                        attrs: {
                          outlined: "",
                          "item-value": "value",
                          "item-text": "title",
                          "return-object": "",
                          "hide-details": "",
                          dense: "",
                          disabled: _vm.isLoading,
                          loading: _vm.isLoading,
                          value: listItemItem.data.condition,
                          items: listItemItem.data.field.conditions,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.mixChangeListItemItemHandler(
                              $event,
                              "where",
                              listItemItemIndex,
                              "condition"
                            )
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              listItemItem.data.condition !== null
                ? _c(
                    "v-col",
                    { attrs: { cols: "5" } },
                    [
                      _c(listItemItem.data.field.component, {
                        tag: "component",
                        attrs: {
                          value: listItemItem.data.value,
                          entity: listItemItem.data.field.entityName,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.mixChangeListItemItemHandler(
                              $event,
                              "where",
                              listItemItemIndex,
                              "value"
                            )
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                { attrs: { cols: "2" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        small: "",
                        disabled: _vm.isLoading,
                        loading: _vm.isLoading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.mixRemoveListItemItemHandler(
                            listItemItemIndex,
                            "where"
                          )
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { color: "red" } }, [
                        _vm._v("mdi-trash-can-outline"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("span", [_vm._v("Количество")]),
              _c("v-text-field", {
                attrs: {
                  type: "number",
                  outlined: "",
                  "hide-details": "",
                  dense: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.limit,
                },
                on: {
                  input: function ($event) {
                    _vm.mixChangeListItemHandler(Number($event), "limit")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("span", [_vm._v("Макет")]),
              _c("v-select", {
                attrs: {
                  outlined: "",
                  "item-value": "value",
                  "item-text": "title",
                  "return-object": "",
                  "hide-details": "",
                  dense: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.layout,
                  items: _vm.$options.layoutsList,
                },
                on: {
                  change: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "layout")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }